/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Logo from "./logo-sm.png";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { setWebsite } from "../../../Slices/website";
import Loader from "../../Loader/Loader";
import {
  getLogo,
  getSupplier,
  getUserId,
} from "../../../lib/Services_with_Query";

const Header = ({ handleShow }) => {
  const dispatch = useDispatch();
  const { website } = useSelector((state) => state?.website || {});
  const website_id = website?.website_id || null;
  const agent_id = website?.agent_id || null;
  const shouldFetch = website_id && agent_id ? true : false;
  var subDomain = window.location.hostname.split(".");

  subDomain = subDomain[0];
  const { data } = useQuery({
    queryKey: ["ids"],
    queryFn: () => getUserId(subDomain),
    enabled: shouldFetch,
  });

  useEffect(() => {
    if (data) {
      dispatch(
        setWebsite({
          website_id: Number(data?.data?.website_id),
          agent_id: Number(data?.data?.subadmin_id),
        })
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const { data: logoData, isLoading: isLogoLoading } = useQuery({
    queryKey: ["getLogo", website_id, agent_id],
    queryFn: () => getLogo(website_id, agent_id),
    enabled: shouldFetch,
  });

  const { data: supplierData, isLoading: isSupplierLoading } = useQuery({
    queryKey: ["getSupplier", website_id, agent_id],
    queryFn: () => getSupplier(agent_id),
    enabled: shouldFetch,
  });

  if (isLogoLoading || isSupplierLoading) return <Loader />;

  return (
    <>
      <header
        className={`header-one header-one1 ${isScrolled ? "scrolled" : ""}`}
      >
        <div
          id="sticker"
          className="header-area header-area-2 header-area-3 header-one1"
        ></div>
        <nav
          className={`navbar navbar-expand-lg fixed-top ${
            isScrolled ? "scrolled" : ""
          }`}
          id="ResponsiveCssNav2"
        >
          <div className="container-fluid">
            <Link to="/" aria-label="Navigate to Home">
              <img
                src={logoData?.logo || Logo}
                alt="Website Logo"
                width="100"
                height="100"
                style={{ borderRadius: "50%" }}
              />
            </Link>
            <button
              className="navbar-toggler text-white"
              type="button"
              data-bs-toggle="collapse"
              onClick={toggleNavbar}
              aria-controls="navbarSupportedContent"
              aria-expanded={isNavbarOpen ? "true" : "false"}
              aria-label="Toggle navigation"
            >
              <FaBars />
            </button>
            <div
              className={`collapse navbar-collapse ${
                isNavbarOpen ? "show" : ""
              }`}
            >
              <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link
                    className="nav-link text-white fs-5 active fs-5"
                    aria-current="page"
                    to={"/"}

                    // Set background to transparent
                  >
                    Home
                  </Link>
                </li>

                {agent_id && website_id ? (
                  <li className="header_menu t-center">
                    <nav id="mobile-menu">
                      <ul className="main-menu">
                        <li className="">
                          <Link to={"/"}>Supplier</Link>
                          <ul className="submenu">
                            {supplierData?.length === 0 && (
                              <li>
                                <Link to={`/`}>Not Found</Link>
                              </li>
                            )}
                            {supplierData?.map((e) => {
                              return (
                                <li>
                                  <Link to={`/blog/${e?.suppliers?.id}`}>
                                    {e?.suppliers?.supplier_name}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </li>
                ) : (
                  <li className="header_menu t-center">
                    <nav id="mobile-menu">
                      <ul className="main-menu">
                        <li className="">
                          <Link to={"/"}>Supplier</Link>
                          <ul className="submenu">
                            {supplierData?.map((e) => {
                              return (
                                <li>
                                  <Link to={`/blog/${e?.id}`}>
                                    {e?.suppliers}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </li>
                )}

                <li className="nav-item">
                  <Link className="nav-link text-white fs-5" to={"/contact"}>
                    Contact
                  </Link>
                </li>
              </ul>
              {/* <form className="d-flex">
                {token ? (
                  <Link
                    to={"/"}
                    onClick={handleShowLogout}
                    className="hd-btn anti-btn"
                  >
                    <i style={{ color: "black", fontSize: "20px" }}>
                
                    </i>
                    Logout
                  </Link>
                ) : (
                  <Link onClick={handleShow} className="hd-btn anti-btn">
                    Sign up/login
                  </Link>
                )}
              </form> */}
            </div>
          </div>
        </nav>
      </header>
      {/* Responsive header  */}
    </>
  );
};

export default Header;
